import {Component, inject, Input, OnInit} from '@angular/core';
import {HealthService} from '../../shared/service/health.service';

@Component({
  selector: 'app-card-cheduled',
  standalone: true,
  imports: [],
  templateUrl: './card-cheduled.component.html',
  styleUrl: './card-cheduled.component.css'
})
export class CardCheduledComponent implements OnInit {

  isAtivo = false;
  @Input() nomeAPi?: string;
  @Input() url?: string;

  private readonly healthService = inject(HealthService);

  ngOnInit(): void {
    this.buscarHealthApi();
  }

  buscarHealthApi(){
    this.healthService.buscarHealthApi(this.url!).subscribe(health => {
      this.isAtivo = health;
    });
  }

}
